import { render, staticRenderFns } from "./PgccCadastro.vue?vue&type=template&id=298c00bc&scoped=true&"
import script from "./PgccCadastro.vue?vue&type=script&lang=js&"
export * from "./PgccCadastro.vue?vue&type=script&lang=js&"
import style0 from "./PgccCadastro.vue?vue&type=style&index=0&id=298c00bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298c00bc",
  null
  
)

export default component.exports